<template>
    <div class="modal-backdrop" role="dialog">
        <div class="modal" ref="modal">
            <header class="modal-header">
                <h2>{{name}} / {{catalogNo}} <small>{{$t('components.shopord.title')}}</small></h2>
                <button type="button" class="btn-close" @click="close">
                    <i class="fas fa-times"></i>
                </button>
            </header>
            <section class="modal-body" style="overflow-y: scroll; overflow-x: hidden">
                <div class="row font-weight-bold">
                    <div class="col-sm-12 col-md text-center text-capitalize" v-if="btnConfigurator">
                        &nbsp;
                    </div>
                    <div class="col-sm-12 col-md text-center text-capitalize" v-if="btnAddCart">
                        &nbsp;
                    </div>
                    <div class="col-sm-12 col-md text-center text-capitalize">
                        {{$t('components.shopord.needweek') | capitalize}}
                    </div>
                    <div class="col-sm-12 col-md text-center text-capitalize">
                        {{$t('components.stocklist.configNoShort') | capitalize}}
                    </div>
                    <div class="col-sm-12 col-md text-center text-capitalize">
                        {{$t('components.products.quantity')}}
                    </div>
                    <div class="col-sm-12 col-md text-center text-capitalize">
                        {{$t('components.products.price')}}
                    </div>
                    <div class="col-sm-12 col-md text-center text-capitalize">
                        {{$t('components.stocklist.acrylicColor')}}
                    </div>
                    <div class="col-sm-12 col-md text-center text-capitalize">
                        {{$t('components.stocklist.cabinetColor')}}
                    </div>
                </div>
                <div v-for="(item) in shopord" :key="item.uniqueId">
                    <a class="row mt-5 mb-5 text-wellis-gold item" v-if="item.hidden !== true">
                        <div class="col-sm-12 col-md text-center font-weight-bold" v-if="btnConfigurator">
                            <router-link :to="{name: 'app.configurator',
                                                        params: {productIdentifier: item.uniqueId},
                                                        query: {host: 'SHOPORD'}}" class="btn btn-sm btn-outline-wellis-black">
                                {{$t('components.stocklist.start-config')}}
                            </router-link>
                        </div>
                        <div class="col-sm-12 col-md text-center font-weight-bold" v-if="btnAddCart">
                            <button :id="`offer_${item.uniqueId}`" class="btn btn-sm btn-outline-wellis-black" @click="addCart(item)">
                                {{$t('components.products.availability.btnAddCart')}}
                            </button>
                            <router-link class="btn btn-sm btn-outline-wellis-black"
                                :to="{name: 'app.shopord.view', params: {uniqueId: item.uniqueId}}">
                                {{$t('components.products.details')}}
                            </router-link>
                        </div>
                        <div class="col-sm-12 col-md text-center">
                            {{$t('components.shopord.readyWeek', {num: item.needWeek})}}
                        </div>
                        <div class="col-sm-12 col-md text-center font-weight-bold cursor-button" @click="viewConfiguration(item.uniqueId, item.configNo)">
                            {{item.configNo}} <i class="fa fa-eye"></i>
                        </div>
                        <div class="col-sm-12 col-md text-center font-weight-bold">
                            {{item.quantity}} {{item.unit}}
                        </div>
                        <div class="col-sm-12 col-md text-center font-weight-bold">
                            <div v-if="hasPrice(item)">
                                <small class="text-black-50 d-block" v-if="item.price.vat">
                                    {{item.price.unitPrice * item.quantity | toPrice(item.price.currency, false)}} + {{$t('components.products.vat')}}
                                </small>
                                {{item.price.unitPrice * item.quantity | toPrice(item.price.currency, item.price.vat)}}
                            </div>
                            <div v-else>
                                -
                            </div>
                        </div>
                        <div class="col-sm-12 col-md text-center">
                            {{item.acrylicColor}}
                        </div>
                        <div class="col-sm-12 col-md text-center">
                            {{item.cabinetColor}}
                        </div>
                    </a>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import CartApiService from "@/api/cart.api";
import {EVENT_CART_COUNT_UPDATE} from "@/core/constants";
import ShopOrdApiService from "@/api/shopord.api";

export default {
    name: "StockMixedShopOrdItems",
    props: {
        name: String,
        catalogNo: String,
        shopord: Array,
        btnConfigurator: Boolean,
        btnAddCart: Boolean
    },

    beforeDestroy() {
        document.body.classList.remove('overflow-hidden');
    },

    methods: {
        close() {
            this.$emit('close');
        },

        addCart(item) {
            let loader = this.$loading.show();
            let attributes = {
                "coordinator": "addProductConfiguration",
                "product": item.uniqueId,
                "quantity": item.quantity,
                "host": 'SHOPORD',
                "configurations": {}
            };

            CartApiService.add(attributes)
                .then(response => {
                    this.$eventBus.$emit(EVENT_CART_COUNT_UPDATE, response.data.count);
                    document.getElementById(`offer_${item.uniqueId}`).classList.add('d-none');
                    this.$parent.$parent.removeItem('shopord', item.uniqueId);
                })
                .catch(error => {
                    if (error.response.data.exception) {
                        if (error.response.data.exception.class === 'DifferentWarehouseException') {
                            this.$swal.fire({
                                icon: "error",
                                html: this.$t('components.cart.different-stocklist-warehouse')
                            });
                        }

                        if (error.response.data.exception.class === 'DifferentStocklistTypeException') {
                            this.$swal.fire({
                                icon: "error",
                                html: this.$t('components.cart.different-stocklist-type')
                            });
                        }

                        if (error.response.data.exception.class === 'UnavailableQuantityException') {
                            this.$swal.fire({
                                zIndex: 9999,
                                icon: "error",
                                html: this.$t('components.cart.unavailable-quantity')
                            });
                        }
                    } else {
                        this.$swal.fire({
                            icon: "error",
                            html: this.$t('components.cart.add-cart-error')
                        });
                    }
                })
                .finally(() => {
                    loader.hide();
                    loader = null;
                });
        },

        viewConfiguration(uniqueId, configNo) {
            let loader = this.$loading.show();
            ShopOrdApiService.getDetails(uniqueId, {
                with_configuration: true
            }).then(response => {
                let body = '<h3 class="float-left">#'+configNo+'</h3><table class="table table-bordered">'
                    + '<tbody>';
                Object.values(response.data.product.configuration).forEach(line => {
                    let value = line.values.find(x => line.selectedValue === x.optionValueId);
                    if(value) {
                        value = value.description;
                    }
                    body += `<tr><td>${line.description}</td><td>${value || line.selectedValue}</td></tr>`;
                })
                this.$swal.fire({
                    html: body + '</tbody></table>',
                    width: "48em"
                });
            }).finally(() => {
                loader.hide();
                loader = null;
            });
        }
    },

    computed: {
        hasPrice() {
            return item => {
                return item.price && typeof item.price !== 'undefined';
            }
        },
    }
}
</script>

<style scoped>
.modal-backdrop {
    position: fixed;
    background-color: rgba(0, 0, 0, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;
    opacity: 1 !important;
    z-index: 9997;
}

.modal {
    width: calc(85%);
    background: #ffffff;
    box-shadow: 2px 2px 20px 1px;
    display: flex;
    flex-direction: column;
    right: 0;
    left: unset;

}

.modal-header {
    padding: 15px;
    display: flex;
}

.modal-header {
    border-bottom: 1px solid #eeeeee;
    color: #b89453;
    justify-content: space-between;
}

.modal-body {
    position: relative;
    padding: 20px 10px;
}

.btn-close {
    border: none;
    font-size: 20px;
    padding: 20px;
    cursor: pointer;
    font-weight: bold;
    color: #b89453;
    background: transparent;
}

.switch {
    position: relative;
    display: inline-block;
    width: 60px;
    height: 34px;
}

.switch input {
    opacity: 0;
    width: 0;
    height: 0;
}

.slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    -webkit-transition: .4s;
    transition: .4s;
}

.slider:before {
    position: absolute;
    content: "";
    height: 26px;
    width: 26px;
    left: 4px;
    bottom: 4px;
    background-color: white;
    -webkit-transition: .4s;
    transition: .4s;
}

input:checked + .slider {
    background-color: #b89453;
}

input:focus + .slider {
    box-shadow: 0 0 1px #b89453;
}

input:checked + .slider:before {
    -webkit-transform: translateX(26px);
    -ms-transform: translateX(26px);
    transform: translateX(26px);
}

.slider.round {
    border-radius: 34px;
}

.slider.round:before {
    border-radius: 50%;
}

.item {
    padding: 20px 0;
    border-bottom: 1px solid #b89453;
    background-color: #f8f8f5;
}
</style>
